<vp-popover
	[disabled]="masterInputConfig.disabled"
	[overruleCreateInstance]="true"
	[popoverId]="'popover' + masterInputConfig.name"
	[showHeader]="false"
	[showPopover]="isPopoverOpen"
	[triggerId]="'trigger-button-' + masterInputConfig.name"
	(isOpen)="popoverStateChanged($event)"
>
	<div #popoverTrigger vc-clicked>
		@if (labelSettings.text) {
			<vp-label
				[inputName]="'trigger-button-' + masterInputConfig.name"
				[labelText]="labelSettings.text"
				[position]="labelSettings.position"
			>
				<ng-container [ngTemplateOutlet]="datepicker" />
			</vp-label>
		} @else {
			<ng-container [ngTemplateOutlet]="datepicker" />
		}
	</div>
	<vp-popover-content>
		<div
			[class.datepicker--hidden]="!isPopoverOpen"
			[id]="'popover-input-' + masterInputConfig.name"
			class="card-md"
		>
			<vp-calendar
				[calendarData]="calendarData"
				[config]="config"
				[isLoading]="isLoading"
				(datePickerEmitter)="onDatePickerEmitter($event)"
				(emitDates)="onEmitDates($event)"
				(emitHasError)="onEmitHasError($event)"
				(emitMonthChange)="onEmitMonthChange($event)"
			/>
		</div>
	</vp-popover-content>
</vp-popover>

<ng-template #datepicker>
	<vp-input
		[autocomplete]="masterInputConfig.autocomplete"
		[defaultStyle]="masterInputConfig.defaultStyle"
		[disabled]="masterInputConfig.disabled"
		[hasError]="isPastDate || masterInputConfig.hasError"
		[icon]="masterInputConfig.icon"
		[iconPosition]="masterInputConfig.iconPosition"
		[initialValue]="prettyDate$ | async"
		[inputId]="'trigger-button-' + masterInputConfig.name"
		[isValid]="masterInputConfig.isValid"
		[name]="masterInputConfig.name"
		[placeholder]="masterInputConfig.placeholder"
		[readonly]="masterInputConfig.readonly"
		[required]="masterInputConfig.required"
		data-test-id="datepicker-input"
	/>
</ng-template>
